module.exports = __webpack_public_path__ + "img/图1-7  聚类任务.c26b73c2.png";